import { decodeBlurhash } from 'src/services/blurhash/blurhash.js'

// Paints a blurhash into a small canvas; CSS scales it up, which gives the
// soft look for free.
const BlurhashCanvas = {
  props: {
    hash: { type: String, required: true },
    width: { type: Number, default: 32 },
    height: { type: Number, default: 32 },
  },
  mounted() {
    this.paint()
  },
  watch: {
    hash() {
      this.paint()
    },
    width() {
      this.paint()
    },
    height() {
      this.paint()
    },
  },
  methods: {
    paint() {
      const pixels = decodeBlurhash(this.hash, this.width, this.height)
      const canvas = this.$refs.canvas
      if (!pixels || !canvas) return
      const context = canvas.getContext('2d')
      const image = context.createImageData(this.width, this.height)
      image.data.set(pixels)
      context.putImageData(image, 0, 0)
    },
  },
}

export default BlurhashCanvas
